<template>
  <div>
    <div v-if="resetDiv">
      <v-row class="flex-column">
        <v-col>
          <h2 class="primary-text">Reset Password</h2>
        </v-col>
        <v-col>
          <v-form ref="form" v-model="valid" class="form-right-view-lable">
            <v-text-field
              v-model="input.password"
              :rules="passwordRules"
              label="Password"
              :append-icon="visible ? 'visibility_off' : 'visibility'"
              :type="visible ? 'password' : 'text'"
              class="subtitle-1 login-text-clr"
              required
              @click:append="() => (visible = !visible)"
            />
            <v-text-field
              v-model="input.reenterpassword"
              :rules="[checkPasswordsMatch]"
              label="Re-Enter Password"
              :append-icon="visible1 ? 'visibility_off' : 'visibility'"
              :type="visible1 ? 'password' : 'text'"
              class="subtitle-1 login-text-clr"
              required
              @click:append="() => (visible1 = !visible1)"
            />
            <!-- <v-text-field
             v-model="input.resetpassword"
             :rules="cpasswordRules"
             label="Re-Enter Password"
             :append-icon="visible ? 'visibility_off' : 'visibility'"
             :type="visible ? 'password' : 'text'"
             class="subtitle-1 login-text-clr"
             required
             @click:append="() => (visible = !visible)"
            /> -->
            <font color="red">{{ text }}</font>
            <!-- <font color="success" class="v-virtual-table">{{ text }}</font> -->
            <v-btn
              depressed
              class="primary_btn small mt-8"
              :disabled="!valid"
              @click="submit"
              >Reset Password</v-btn
            >
          </v-form>
        </v-col>
      </v-row>
    </div>
    <div v-if="tokenValid">
      <h2 class="primary-text pb-5">Reset Password</h2>
      <font color="red">{{ tokenInvalidMessage }}</font>
      <a @click="$router.replace('/ForgotPassword')"> Please try again.</a>
    </div>
  </div>
</template>

<script>
// import { emailRules } from '@/support/utils/form-rules.js';
import { resetPasswordRules } from '@/support/utils/form-rules';
// import {cpasswordRules} from '@/support/utils/form-rules';
import { storeActions } from '@/store/actions.constants';
import { mapActions, mapGetters } from 'vuex';
export default {
  data: () => ({
    valid: true,
    passwordRules: resetPasswordRules,
    input: {
      password: null,
      reenterpassword: null,
    },
    forgotResponse: {},
    response: '',
    text: '',
    headers: '',
    visible: true,
    visible1: true,
    tokenValid: false,
    resetDiv: false,
    tokenInvalidMessage: '',
  }),
  computed: {
    ...mapGetters({
      authenticatedResult: 'user/authenticationResult',
      triggerSnackBar: 'alerts/triggerSnackBar',
    }),
    checkPasswordsMatch() {
      if (this.input.password === this.input.reenterpassword) {
        return true;
      } else {
        return 'Password must match';
      }
    },
  },
  created() {
    // this.submit();
    this.test();
  },
  methods: {
    ...mapActions({
      userResetPassword: 'users/resetPassword',
      isTokenValidForQentelli: 'users/isTokenValidForQentelli',
    }),
    submit: async function() {
      //   if (this.$refs.form.validate()) {
      let urlParams = new URLSearchParams(window.location.search);
      this.token = urlParams.get('token');
      var payload = {
        data: {
          password: this.input.password,
          headers: { origin: window.location.origin },
        },
        token: this.token,
      };
      this.resetResponse = await this.userResetPassword(payload);
      let statuscode = this.resetResponse.status;
      if (statuscode === 200) {
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Your password has been changed successfully!',
          timeout: 1000,
          color: 'success',
        });
        // let props = {
        //   content: 'Your password has been changed successfully!',
        //   buttonText: 'close',
        // };
        // this.triggerSnackBar(props);
        this.$router.replace('/');
      } else if (statuscode === 400) {
        // this.snackbar = true
        this.text = 'Password reset token is invalid or has expired';
      }
      //   }
    },
    test: async function() {
      let urlParams = new URLSearchParams(window.location.search);
      this.token = urlParams.get('token');
      var payload = {
        token: this.token,
      };
      let response = await this.isTokenValidForQentelli(payload);
      if (response.status === 400) {
        this.tokenValid = true;
        this.tokenInvalidMessage = 'Password Link Expired.';
      } else {
        this.resetDiv = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-virtual-table {
  position: absolute;
}
</style>
